// Jquery ready function used for cross browser compatibilities.
$(document).ready(function() {
  if (document.querySelector('.site-header__user_login_btn')) {
    document.querySelector('.login-cross-btn').addEventListener('click', function (e) {
    slideOutPopupLogin();
    });
    
    document.querySelector('.popup-login-background-layer').addEventListener('click', function (e) {
    slideOutPopupLogin();
    });

    document.querySelector('.site-header__user_login_btn').addEventListener('click', function (e) {
      // CSS display block applied here so the slide in animation works properly. 
      document.querySelector('.login-slider').style.display = "block";
      
      document.querySelector('.popup-login-background-layer').classList.add('dimmed');
      document.querySelector('.login-slider').classList.remove('deactivate');
      document.querySelector('.login-slider').classList.add('activate');
      document.querySelector('html').classList.add('scroll-locked');
      document.querySelector('body').classList.add('scroll-locked');
    });
    
    function slideOutPopupLogin() {
      document.querySelector('.popup-login-background-layer').classList.remove('dimmed');
      document.querySelector('.login-slider').classList.remove('activate');
      document.querySelector('.login-slider').classList.add('deactivate');
      document.querySelector('html').classList.remove('scroll-locked');
      document.querySelector('body').classList.remove('scroll-locked');   
      
    // This function below is required to prevent the popup login to be visible after closing it.     
      setTimeout(() => {
        document.querySelector('.login-slider').style.display = "none";            
      }, 500);
    }
  }
});